import { ENDPOINT } from "./FormData";
import { extractErrorMessage } from "../utility-function/ApiError";

// RegistrationData handles registration-related API calls
export class RegistrationData {
    static instance: RegistrationData = new RegistrationData()

    getFullAddress(addressStreet: string, addressCity: string, addressState: string, addressZipcode: string): string {
        const fullAddress = `${addressStreet}\n${addressCity}, ${addressState} ${addressZipcode}`
        return fullAddress === '\n,  ' ? '' : fullAddress
    }

    /**
     * Checks if the user is already registered.
     * 
     * @param emailAddress - The email address to check
     * @param phoneNumber - The phone number to check
     * @param ifRegistered - Callback to call when user is already registered
     * @param ifNotRegistered - Callback to call when user is NOT registered
     */
    userAlreadyRegistered(
        emailAddress: string,
        phoneNumber: string,
        ifRegistered: (email_registered: boolean, phone_registered: boolean) => void,
        ifNotRegistered: (data: any) => void
    ): void {
        const queryParams = new URLSearchParams({
            email: emailAddress,
            cell: phoneNumber
        });

        fetch(`${ENDPOINT}/isalreadyregistered?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.email_registered || data.phone_registered) {
                    ifRegistered(data.email_registered, data.phone_registered);
                } else {
                    ifNotRegistered(data);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    /**
     * Registers a new user and sends a confirmation email.
     * 
     * @param provider - The name of the healthcare provider or organization
     * @param programs - Array of program identifiers the user is enrolling in
     * @param selectedLanguage - User's preferred language (e.g., 'english', 'spanish')
     * @param firstName - User's first name
     * @param lastName - User's last name
     * @param phoneNumber - User's phone number (in international format, e.g., '+1234567890')
     * @param email - User's email address
     * @param preferredContactMethod - Array of preferred contact methods (e.g., ['email', 'phone'])
     * @param bpCuff - User's blood pressure cuff 
     * @param glucometer - User's glucometer
     * @param address - User's address
     * @param subscription_months - Subscription duration in months
     * @param callbackSuccess - Function to call on successful registration
     * @param callbackFail - Function to call if registration fails
     */
    registerUser(
        provider: string,
        programs: string[],
        selectedLanguage: string,
        firstName: string,
        lastName: string,
        phoneNumber: string,
        email: string,
        preferredContactMethod: string[],
        bpCuff: string,
        glucometer: string,
        studyArm: string,
        address: string,
        subscription_months: string,
        callbackSuccess: () => void,
        callbackFail: (errorMessage?: string) => void
    ): void {
        // Prepare the request payload
        const submitData = {
            provider: provider,
            programs: programs,
            language_id: selectedLanguage,
            first_name: firstName,
            last_name: lastName,
            cell: '+' + phoneNumber,
            email: email,
            preferred_contact_method: preferredContactMethod,
            bp_cuff: bpCuff,
            glucometer: glucometer,
            study_arm: studyArm,
            address: address,
            subscription_months: subscription_months,
            time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
        console.log('submitData:', JSON.stringify(submitData))

        // Send POST request to register patient
        fetch(`${ENDPOINT}/patient`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(submitData)
        })
            .then(async response => {
                console.log('Server Response:', response)
                if (response.ok) {
                    callbackSuccess()
                    return
                }
                const bodyText = await response.text().catch(() => '')
                callbackFail(extractErrorMessage(bodyText, response.status))
            })
            .catch(e => {
                console.log('Network Issue: ' + e)
                callbackFail()
            })
    }
}
